export const menuRoles = {
    itemMenu: {
        freelancer: {
            roles: ['PORTAL_FREELANCER_EXTERNO']
        }
    }
};
